(function (b, C) {
  typeof exports == 'object' && typeof module < 'u'
    ? C(exports)
    : typeof define == 'function' && define.amd
      ? define(['exports'], C)
      : ((b = typeof globalThis < 'u' ? globalThis : b || self),
        C((b.DTXWeb = {})));
})(this, function (b) {
  'use strict';
  var C = typeof document < 'u' ? document.currentScript : null;
  class V {}
  class X extends V {
    constructor(e, t, r, n) {
      super(),
        (this.html = e),
        (this.width = t),
        (this.height = r),
        (this.metadata = n || {});
    }
    getContent() {
      return new O(this);
    }
  }
  class O {
    constructor(e) {
      this.adMarkup = e;
    }
  }
  class U {
    constructor(e, t) {
      (this.success = e), (this.error = t);
    }
  }
  class x extends Error {
    constructor(e) {
      super(e),
        (this.name = 'OpenRTBSDKError'),
        Object.setPrototypeOf(this, x.prototype);
    }
  }
  var E = ((i) => (
    (i.AD_REQUEST_COMPLETED = 'adRequestCompleted'),
    (i.AD_REQUEST_FAILED = 'adRequestFailed'),
    i
  ))(E || {});
  class p extends Error {
    constructor(e, t, r) {
      super(e),
        (this.name = 'HttpClientError'),
        (this.statusCode = t),
        (this.responseBody = r),
        Object.setPrototypeOf(this, p.prototype);
    }
  }
  const z = (i, e, t, r) => {
      const n = document.createElement('iframe');
      t > 0 && (n.width = `${t}`),
        e > 0 && (n.height = String(e)),
        (n.marginWidth = '0'),
        (n.marginHeight = '0'),
        n.setAttribute('id', i);
      const a = window.location.protocol === 'https:';
      let s = r;
      if ((a && (s = s.replace(/http:\/\//g, 'https://')), s)) {
        let d = s;
        const o = r.toLowerCase(),
          u = `<script>(function(){var adId=${JSON.stringify(i)};var m=window.mraid=window.mraid||{},l={},s='loading',v=!1;m.addEventListener=function(e,t){l[e]=l[e]||[];l[e].indexOf(t)===-1&&l[e].push(t)},m.removeEventListener=function(e,t){if(l[e]){var i=l[e].indexOf(t);i!==-1&&l[e].splice(i,1)}};var f=function(e){if(l[e]){var t=Array.prototype.slice.call(arguments,1);l[e].forEach(function(e){e.apply(null,t)})}};m.getState=function(){return s},m.isViewable=function(){return v},m.open=function(e){window.open(e,'_blank')},m.supports=function(e){return!1},m.useCustomClose=function(u){};var c=function(e){s!==e&&(s=e,f('stateChange',s))},a=function(e){v!==e&&(v=e,f('viewableChange',v))};var o=function(){c('default'),f('ready');try{window.parent.postMessage({dtxAdEvent:'adDocumentDOMContentLoaded',adId:adId},'*')}catch(e){}};window.addEventListener('message',function(e){if(e.data&&e.data.dtxAdEvent==='viewabilityChange'){a(e.data.isViewable)}});document.readyState==='complete'||document.readyState!=='loading'&&!document.documentElement.doScroll?o():document.addEventListener('DOMContentLoaded',o)})();<\/script>`,
          c = `<script>
            (function() {
                const adId = '${i}';
                console.log('DTX SDK: Click hijacker script initialized for ad: ' + adId);
                function safeClickHandler(event) {
                    console.log('DTX SDK: [Hijacker] Event captured in ad ' + adId + ' on element:', event.target);
                    let target = event.target;
                    while (target && target.tagName !== 'A') {
                        target = target.parentElement;
                    }
                    if (target && target.href) {
                        console.log('DTX SDK: [Hijacker] Anchor found for ad ' + adId + '. Preventing default action. Href: ' + target.href);
                        if (event.type !== 'touchstart') {
                            event.preventDefault();                            
                        }
                        event.stopImmediatePropagation();
                        console.log('DTX SDK: [Hijacker] Posting "click" message with href to parent for ad ' + adId);
                        window.parent.postMessage({ dtxAdEvent: 'click', adId: adId, href: target.href, eventType: event.type }, '*');
                    } else {
                        console.log('DTX SDK: [Hijacker] Click captured in ad ' + adId + ', but no parent anchor with href was found.');
                    }
                }
                document.addEventListener('click', safeClickHandler, { capture: true });
                document.addEventListener('touchstart', safeClickHandler, { capture: true, passive: false });
            })();
        <\/script>`;
        o.indexOf('<html') < 0
          ? (d = `<!DOCTYPE html><html><head><style>html,body{margin:0;padding:0;width:100%;height:100%;overflow:hidden;}body>*{width:100%;height:100%;box-sizing:border-box;}</style>${u}${c}</head><body>${s}</body></html>`)
          : (d = s.replace(/<head>/i, `<head>${u}${c}`)),
          n.setAttribute('srcdoc', d);
      }
      return (
        n.setAttribute('frameborder', '0'),
        n.setAttribute('scrolling', 'no'),
        n.setAttribute(
          'sandbox',
          'allow-forms allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts allow-top-navigation-by-user-activation'
        ),
        n.setAttribute(
          'allow',
          'private-state-token-redemption;attribution-reporting'
        ),
        n.setAttribute('title', 'Third party ad content'),
        n
      );
    },
    K = () =>
      new Promise((i) => {
        typeof document < 'u' && (document.body || document.documentElement)
          ? i()
          : document.addEventListener('DOMContentLoaded', () => {
              i();
            });
      }),
    W = () => {
      const i = $(),
        e = navigator.maxTouchPoints || 0,
        t = window.screen.width,
        r = window.screen.height,
        n =
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|rim)|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            i
          ),
        a = /iphone/i.test(i) && t <= 768,
        s = /android/i.test(i) && n && t <= 768,
        d = Math.min(t, r) <= 768;
      if (n || a || s || (d && e > 0)) return 'phone';
      const o =
          /(ipad|tablet|(android(?!.*mobile))|kindle|playbook|silk|(p(ixi|rim)|htc[-_]?touch|fennec|rim tablet|hp cpaq|hp i|palmsource|go.web|hp.tablet|fennec|series 60|opera tablet|android 3\.|windows ce|blackberry|playbook|hp-tablet|xoom|sch-i800|bada|maemo|windows mobile|iphone|ipod|blackberry|opera mini|blazer|kindle|playbook|silk|tablet|ipad|Nexus 7|Nexus 10|SM-T.*))/i.test(
            i
          ) && !n,
        u = /ipad/i.test(i),
        c = e > 0 && Math.max(t, r) > 768 && Math.max(t, r) <= 1280;
      if (o || u || c) return 'tablet';
      const h = /windows|macintosh|linux|x11/i.test(i);
      return e === 0 || h || Math.max(t, r) > 1280 ? 'desktop' : 'unknown';
    },
    q = () => window.location.href,
    $ = () => navigator.userAgent || navigator.vendor || window.opera,
    Y = async (i, e) => {
      try {
        const t = await i.fetchAd(e);
        return (
          l
            .getInstance()
            .emit(E.AD_REQUEST_COMPLETED, {
              status: { success: !0 },
              responsePayload: t,
              requestPayload: e,
            }),
          t
        );
      } catch (t) {
        t instanceof p
          ? l
              .getInstance()
              .emit(E.AD_REQUEST_FAILED, {
                status: {
                  success: !1,
                  statusCode: t.statusCode,
                  error: t.message,
                },
                requestPayload: e,
              })
          : l
              .getInstance()
              .emit(E.AD_REQUEST_FAILED, {
                status: {
                  success: !1,
                  statusCode: -1,
                  error:
                    t.message ||
                    'An unknown error occurred while fetching the ad.',
                },
                requestPayload: e,
              });
      }
    },
    G = (i) => {
      try {
        return new URL(i).hostname;
      } catch (e) {
        return console.error(`Invalid URL provided: ${i}`, e), null;
      }
    },
    N = (i) => {
      const e = i.match(/^v?(\d+)(?:\.(\d+))?(?:\.(\d+))?.*$/i);
      if (e) {
        const t = parseInt(e[1], 10) || 0,
          r = parseInt(e[2], 10) || 0,
          n = parseInt(e[3], 10) || 0;
        return { major: t, minor: r, micro: n };
      } else
        return (
          console.warn(`Could not extract version parts from: "${i}"`), null
        );
    },
    B = () => {
      switch (W()) {
        case 'phone':
          return 4;
        case 'tablet':
          return 1;
        case 'desktop':
          return 2;
        default:
          return (
            console.warn(
              'Unable to determine device type from browser, defaulting to phone'
            ),
            4
          );
      }
    },
    F = (i) => {
      const e = i.match(/Android\s+([\d.]+)/i);
      return e && e[1] ? { os: 'android', osv: e[1] } : {};
    },
    H = (i) => {
      const e = i.publisherId
          ? {
              id: i.publisherId,
              ext: {
                installed_sdk: {
                  id: 'content_media',
                  sdk_version: i.sdkVersion,
                },
              },
            }
          : void 0,
        t = {};
      if (i.appBundle) {
        const r = { bundle: i.appBundle };
        i.appName && (r.name = i.appName),
          i.appVer && (r.ver = i.appVer),
          e && (r.publisher = e),
          (t.app = r);
      }
      if (i.siteId) {
        const r = { id: i.siteId };
        i.domain != null && (r.domain = i.domain),
          i.page != null && (r.page = i.page),
          e && (r.publisher = e),
          (t.site = r);
      }
      return t;
    },
    J = (i, e, t, r, n, a, s, d, o, u, c, h, m, T, w) => {
      const g = G(r),
        M = N(s),
        y = B(),
        v = { ua: n, dnt: 0, lmt: 0, devicetype: y, language: e, ...F(n) };
      o &&
        ((v.ifa = o),
        u &&
          (v.ext = { ...v.ext, ifa_type: u === 'android' ? 'aaid' : 'idfa' }));
      const f = {
        id: crypto.randomUUID(),
        imp: [
          {
            id: crypto.randomUUID(),
            banner: {
              ...t,
              pos: 1,
              mimes: [
                'text/html',
                'text/javascript',
                'image/png',
                'image/jpeg',
                'image/gif',
              ],
            },
            displaymanager: 'DigitalTurbine',
            rwdd: 0,
            instl: 0,
            tagid: i,
            secure: 0,
            ext: { gpid: i },
          },
        ],
        device: v,
        tmax: a,
        regs: { ext: { us_privacy: '1NNN', gdpr: 0 } },
      };
      m?.length && (f.iab_category = m),
        h ||
          console.warn(
            'Missing publisher ID, this is needed to create the publisher object in the request.'
          ),
        c ||
          console.warn(
            'Missing site ID, this is needed to create the site object in the request.'
          );
      const { site: I, app: D } = H({
        siteId: c,
        publisherId: h,
        domain: g,
        page: r,
        sdkVersion: M ?? { major: 1, minor: 0, micro: 0 },
        appBundle: d?.packageName,
        appName: d?.appName,
        appVer: d?.appVersion,
      });
      return (
        I && (f.site = I),
        D && (f.app = D),
        w && (f.user = { id: w }),
        T && (f.ext = T),
        f
      );
    };
  function Q(i) {
    const e = {};
    return (
      i.length > 0
        ? ((e.w = i[0].width),
          (e.h = i[0].height),
          (e.format = i.map((t) => ({ w: t.width, h: t.height }))))
        : (console.warn('no banner sizes provided, defaulting to 320x50'),
          (e.w = 320),
          (e.h = 50),
          (e.format = [{ w: 320, h: 50 }])),
      e
    );
  }
  class Z {
    constructor(e, t) {
      (this.requests = []),
        (this.deviceLanguage = 'en'),
        (this.config = e),
        (this.adClientFactory = t);
    }
    setBannerSizes(e) {
      return (this.bannerSizes = e), this;
    }
    setDeviceLanguage(e) {
      return (this.deviceLanguage = e), this;
    }
    setTestData(e) {
      return (this.testData = e), this;
    }
    verifyBidResponse(e) {
      if (
        (console.debug(`Verifying BidResponse: ${JSON.stringify(e)}`),
        !e?.seatbid?.length ||
          !e.seatbid[0].bid?.length ||
          !e.seatbid[0].bid[0])
      )
        throw new x(
          'Invalid or empty BidResponse structure received (no bid found).'
        );
    }
    verifyBidRequest(e) {
      if ((console.debug(`Verifying BidRequest: ${JSON.stringify(e)}`), !e))
        throw new x('Missing bid request');
      if (this.requests?.some((t) => t.bidRequest.id === e.id))
        throw new x(
          'An existing request has already been made with this bid ID'
        );
    }
    async load(e, t) {
      const r = new Date().getTime();
      l.getInstance().emit('ad_requested', { placementId: e, startAt: r });
      try {
        const n = J(
          e,
          this.deviceLanguage,
          Q(this.bannerSizes),
          q(),
          $(),
          this.config.tmax,
          re,
          this.config.hostingAppDetails,
          this.config.advertiserId,
          this.config.advertiserIdType,
          this.config.siteId,
          this.config.publisherId,
          t,
          this.testData,
          this.config.userId
        );
        this.verifyBidRequest(n);
        const a = await Y(this.adClientFactory, n);
        if (a) this.verifyBidResponse(a);
        else throw new x('No bid response received');
        const s = new Date().getTime();
        return (
          l
            .getInstance()
            .emit('ad_loaded', {
              placementId: e,
              price: a.seatbid[0].bid[0].price,
              creativeId: a.seatbid[0].bid[0].crid,
              campaignId: a.seatbid[0].bid[0].cid,
              adDomain: a.seatbid[0].bid[0].adomain,
              endedAt: s,
              roundtrip: s - r,
            }),
          a
        );
      } catch (n) {
        const a = new Date().getTime();
        throw (
          (l
            .getInstance()
            .emit('ad_load_failed', {
              placementId: e,
              endedAt: a,
              roundtrip: a - r,
            }),
          n)
        );
      }
    }
  }
  class R {
    constructor(e) {
      (this.impressionFired = !1),
        (this.loadCalled = !1),
        (this.id = e),
        (this.status = 'initialized');
    }
    render(e, t) {
      if (!this.adContent) {
        console.error(
          'DTX SDK: Ad content is not loaded. Call request() before render().'
        );
        return;
      }
      if (
        ((this.impressionTimeout = window.setTimeout(() => {
          this.impressionFired || this.emitMetric('impression_timeout');
        }, 15e3)),
        t && e)
      ) {
        const r = (n) => {
          n.source !== t.contentWindow ||
            !n.data ||
            n.data.dtxAdEvent !== 'adDocumentDOMContentLoaded' ||
            (n.data.adId === t.id &&
              (this.impressionMessageCleanup?.(),
              (this.impressionMessageCleanup = void 0),
              this.emit('impression', { targetElementId: e }),
              this.setupViewabilityObserver(e, t)));
        };
        window.addEventListener('message', r),
          (this.impressionMessageCleanup = () => {
            window.removeEventListener('message', r);
          });
      } else
        this.emit('impression', { targetElementId: e }),
          e && this.setupViewabilityObserver(e, t);
    }
    dispose() {
      this.loadCalled &&
        !this.impressionFired &&
        this.emitMetric('disposed_before_impression'),
        this.impressionMessageCleanup?.(),
        (this.impressionMessageCleanup = void 0),
        this.viewabilityObserver && this.viewabilityObserver.disconnect(),
        this.impressionTimeout && clearTimeout(this.impressionTimeout),
        (this.status = 'disposed');
    }
    setupViewabilityObserver(e, t) {
      const r = document.getElementById(e);
      if (!r) {
        console.error(
          `DTX SDK: Could not find element with ID '${e}' to observe for viewability.`
        );
        return;
      }
      let n = !1,
        a = !1;
      (this.viewabilityObserver = new IntersectionObserver(
        (s) => {
          const o = s[0].isIntersecting;
          o && !n
            ? ((n = !0),
              (this.status = 'visible'),
              t?.contentWindow &&
                t.contentWindow.postMessage(
                  { dtxAdEvent: 'viewabilityChange', isViewable: !0 },
                  '*'
                ),
              a ||
                (this.emit('viewableImpression', { targetElementId: e }),
                (a = !0)))
            : !o &&
              n &&
              ((n = !1),
              (this.status = 'not-visible'),
              t?.contentWindow &&
                t.contentWindow.postMessage(
                  { dtxAdEvent: 'viewabilityChange', isViewable: !1 },
                  '*'
                ));
        },
        { threshold: 0.5 }
      )),
        this.viewabilityObserver.observe(r);
    }
    emit(e, t) {
      e === 'impression' &&
        ((this.impressionFired = !0),
        this.impressionTimeout && clearTimeout(this.impressionTimeout));
      try {
        l.getInstance().emit(e, {
          placementId: this.id,
          ...this.adContent.adMarkup.metadata,
          impressionUrls: this.adContent.impressionUrls,
          clickUrls: this.adContent.clickUrls,
          ...t,
        });
      } catch (r) {
        e === 'impression' &&
          this.emitMetric('impression_error', { error: r.message });
      }
    }
    emitMetric(e, t) {
      l.getInstance().emit('adMetric', {
        placementId: this.id,
        metric: e,
        ...t,
      });
    }
    getImpressionUrl() {
      return this.adContent?.impressionUrls;
    }
    getClickUrl() {
      return this.adContent?.clickUrls;
    }
    async request(e) {
      (this.loadCalled = !0), await K();
      const t = l.getInstance()._getConfig(),
        r = l.getInstance()._getAdClientFactory(),
        n = new Z(t, r);
      e &&
        (n.setBannerSizes(e.bannerSizes || []),
        n.setDeviceLanguage(e.deviceLanguage),
        n.setTestData(e.testData));
      try {
        const a = await n.load(this.id, e.iabCategories);
        return (this.adContent = this.generateAdContent(a)), new U(!0);
      } catch (a) {
        return new U(!1, a);
      }
    }
    getWinPrice() {}
  }
  class ee extends R {
    generateAdContent(e) {
      const t = new O(
        new X(
          e.seatbid[0].bid[0].adm,
          e.seatbid[0].bid[0].w,
          e.seatbid[0].bid[0].h,
          {
            creativeId: e.seatbid[0].bid[0].crid,
            campaignId: e.seatbid[0].bid[0].cid,
            adDomain: e.seatbid[0].bid[0].adomain,
          }
        )
      );
      return (
        (t.impressionUrls = e.seatbid[0].bid[0].ext.imptrackers),
        (t.clickUrls = e.seatbid[0].bid[0].ext.clicktrackers),
        t
      );
    }
    setContent(e) {
      this.adContent = e;
    }
    render(e) {
      if (((this.container = document.getElementById(e)), !this.container)) {
        console.error(
          `DTX SDK: Could not find element with ID '${e}' to render ad into.`
        );
        return;
      }
      this.container.replaceChildren(),
        (this.iframe = z(
          `dtx_ads_iframe_${this.id}`,
          this.adContent.adMarkup.height,
          this.adContent.adMarkup.width,
          this.adContent.adMarkup.html
        ));
      const t = (r) => {
        r.data &&
          (r.data.dtxAdEvent &&
            console.log('DTX SDK: [Parent] Message handler received event:', {
              adId: this.id,
              data: r.data,
            }),
          !(
            r.source !== this.iframe.contentWindow ||
            !r.data ||
            r.data.dtxAdEvent !== 'click'
          ) &&
            (r.data.adId === `dtx_ads_iframe_${this.id}`
              ? (console.log(
                  'DTX SDK: [Parent] Click event confirmed for ad ' +
                    this.id +
                    '. Emitting click.'
                ),
                r.data.eventType === 'click' && this.emit('click', {}),
                r.data.href &&
                  (console.log(
                    'DTX SDK: [Parent] Opening link from parent context: ' +
                      r.data.href
                  ),
                  window.open(r.data.href, '_blank')))
              : console.warn(
                  'DTX SDK: [Parent] Click message received, but adId did not match.',
                  {
                    expected: `dtx_ads_iframe_${this.id}`,
                    received: r.data.adId,
                  }
                )));
      };
      window.addEventListener('message', t),
        this.container.appendChild(this.iframe),
        super.render(e, this.iframe);
    }
    dispose() {
      super.dispose();
    }
  }
  class te extends R {
    show() {
      (this.overlay = document.createElement('div')),
        (this.overlay.style.position = 'fixed'),
        (this.overlay.style.top = '0'),
        (this.overlay.style.left = '0'),
        (this.overlay.style.width = '100%'),
        (this.overlay.style.height = '100%'),
        (this.overlay.style.background = 'rgba(0,0,0,0.8)'),
        document.body.appendChild(this.overlay),
        this.viewabilityObserver.observe(this.overlay),
        this.render();
    }
    render() {
      this.overlay.innerHTML = `<div>Interstitial Ad: ${this.id}</div>`;
    }
    dispose() {
      this.overlay && document.body.removeChild(this.overlay), super.dispose();
    }
  }
  class ie {
    constructor(e) {
      if (
        ((this.apiUrl = 'https://wv.inner-active.mobi/simpleM2M/contentMedia'),
        e.attempts < 1)
      )
        throw new Error('Retry attempts must be at least 1.');
      if (e.maxDuration <= 0)
        throw new Error('Max duration for retries must be positive.');
      (this.httpTimeout = e.httpTimeout || 3e3),
        (this.retryConfig = { initialDelay: 300, ...e });
    }
    async fetchAd(e) {
      let t = new p('Ad request failed after all retries.', 503);
      const r = Date.now();
      for (let n = 1; n <= this.retryConfig.attempts; n++) {
        if (Date.now() - r >= this.retryConfig.maxDuration) {
          console.warn(
            `[RetryableHttpClient] Max duration of ${this.retryConfig.maxDuration}ms exceeded before attempt ${n}. Aborting.`
          ),
            (t = new p(
              `Max duration exceeded. Failed after ${Date.now() - r}ms.`,
              408
            ));
          break;
        }
        const s = new AbortController(),
          d = setTimeout(() => s.abort(), this.httpTimeout);
        try {
          const o = await fetch(this.apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(e),
            signal: s.signal,
          });
          if (o.status === 204) {
            t = new p('No fill');
            break;
          }
          if (o.ok) return await o.json();
          let u;
          try {
            u = await o.text();
          } catch (c) {
            console.warn('Error getting text from response', c);
          }
          if (
            ((t = new p(
              `[RetryableHttpClient] HTTP error ${o.status} on attempt ${n}. Body: ${u || '(empty)'}`,
              o.status,
              u
            )),
            o.status < 500 || o.status >= 600)
          ) {
            console.warn(
              `[RetryableHttpClient] Non-retryable HTTP status ${o.status} on attempt ${n}.`
            );
            break;
          }
        } catch (o) {
          o instanceof DOMException && o.name === 'AbortError'
            ? (t = new p(
                `[RetryableHttpClient] Request timed out after ${this.httpTimeout}ms on attempt ${n}.`,
                408
              ))
            : o instanceof Error
              ? (t = o)
              : (t = new p(
                  '[RetryableHttpClient] An unknown network error occurred.',
                  void 0,
                  o
                )),
            console.warn(
              `[RetryableHttpClient] Network error on attempt ${n}:`,
              t.message
            );
        } finally {
          clearTimeout(d);
        }
        if (n < this.retryConfig.attempts) {
          const o = this.retryConfig.maxDuration - (Date.now() - r);
          if (o <= 0) {
            console.warn(
              '[RetryableHttpClient] Max duration would be exceeded by next retry. Aborting.'
            );
            break;
          }
          const u = Math.min(
            this.retryConfig.initialDelay * Math.pow(2, n - 1),
            o
          );
          console.log(
            `[RetryableHttpClient] Attempt ${n} failed. Retrying in ${u}ms...`
          ),
            await new Promise((c) => setTimeout(c, u));
        }
      }
      throw t;
    }
    async fireAndForget(e) {
      let t = new p('Request failed after all retries.', 503);
      const r = Date.now();
      for (let n = 1; n <= this.retryConfig.attempts; n++) {
        if (Date.now() - r >= this.retryConfig.maxDuration) {
          t = new p(
            `Max duration of ${this.retryConfig.maxDuration}ms exceeded. Aborting.`
          );
          break;
        }
        try {
          await fetch(e, { method: 'GET', mode: 'no-cors', keepalive: !0 });
          return;
        } catch (s) {
          s instanceof Error
            ? (t = s)
            : (t = new p('An unknown network error occurred.', void 0, s));
        }
        if (n < this.retryConfig.attempts) {
          const s = this.retryConfig.initialDelay * Math.pow(2, n - 1);
          await new Promise((d) => setTimeout(d, s));
        }
      }
      throw t;
    }
  }
  class _ {
    constructor(e) {
      (this.defaultRetryConfig = { attempts: 1, maxDuration: 2e3 }),
        (this.adClient = new ie(e || this.defaultRetryConfig));
    }
    async fetchAd(e) {
      return await this.adClient.fetchAd(e);
    }
    setAdClient(e) {
      this.adClient = e;
    }
    getAdClient() {
      return this.adClient;
    }
  }
  const ne = {
      bannerCycleTime: 5e3,
      retryConfig: { attempts: 3, maxDuration: 7500, initialDelay: 100 },
      advertiserIdType: 'android',
    },
    re = 'v0.1.22';
  class l {
    constructor() {
      this.eventListeners = {};
    }
    static getInstance() {
      return l.instance || (l.instance = new l()), l.instance;
    }
    initialize(e) {
      (this.config = { ...ne, ...e }),
        (this.adClientFactory = new _(e?.retryConfig));
      const r = new _({
        attempts: 5,
        maxDuration: 3e4,
        initialDelay: 250,
        httpTimeout: 3e3,
      }).getAdClient();
      this.addEventListener('impression', async (n) => {
        const a = n.impressionUrls;
        if (a) {
          try {
            await Promise.all(a.map((s) => r.fireAndForget(s)));
          } catch (s) {
            console.error('Failed to fire impression pixel:', s);
          }
          console.log('Impression recorded:', n);
        }
      }),
        this.addEventListener('click', async (n) => {
          const a = n.clickUrls;
          if (a)
            try {
              await Promise.all(a.map((s) => r.fireAndForget(s)));
            } catch (s) {
              console.error('Failed to fire click pixel:', s);
            }
        });
    }
    _getConfig() {
      return this.config;
    }
    _getAdClientFactory() {
      return this.adClientFactory;
    }
    setAdClient(e) {
      this.adClientFactory.setAdClient(e);
    }
    addEventListener(e, t) {
      this.eventListeners[e] || (this.eventListeners[e] = []),
        this.eventListeners[e].push(t);
    }
    removeEventListener(e, t) {
      this.eventListeners[e] &&
        (this.eventListeners[e] = this.eventListeners[e].filter(
          (r) => r !== t
        ));
    }
    emit(e, t) {
      this.eventListeners[e] && this.eventListeners[e].forEach((r) => r(t));
    }
    banner(e) {
      return new ee(`${e}`);
    }
    interstitial(e) {
      return new te(`interstitial-${e}`);
    }
  }
  function ae(i, e) {
    const r =
        window.location.protocol === 'https:'
          ? i.replace(/http:\/\//g, 'https://')
          : i,
      a = `var DBG=${window.__dtxCreativeDebug === !0};`,
      s = `<script>(function(){${a}
window.__dtxNav=function(url){
if(!url)return false;
if(window.__dtxNavUrl===url&&Date.now()-(window.__dtxNavAt||0)<1000){return true}
window.__dtxNavUrl=url;window.__dtxNavAt=Date.now();
var how='';
try{if(window.open(url,'_blank'))how='window.open'}catch(e){}
if(!how){try{window.top.location.href=url;how='top.location'}catch(e){}}
if(!how){try{window.location.href=url;how='location'}catch(e){}}
try{window.parent.postMessage({dtxAdEvent:'click',href:url},'*')}catch(e){}
if(DBG)console.log('[DTX nav]',how||'BLOCKED',url);
return !!how};
})();<\/script>`,
      d = `<script>(function(){${a}var m=window.mraid=window.mraid||{},l={},s='loading';m.addEventListener=function(e,t){l[e]=l[e]||[];l[e].indexOf(t)===-1&&l[e].push(t)};m.removeEventListener=function(e,t){if(l[e]){var i=l[e].indexOf(t);if(i!==-1)l[e].splice(i,1)}};var f=function(e){if(l[e]){var a=Array.prototype.slice.call(arguments,1);l[e].forEach(function(fn){fn.apply(null,a)})}};m.getState=function(){return s};m.isViewable=function(){return document.visibilityState!=='hidden'};m.open=function(url){if(DBG)console.log('[DTX mraid.open]',url);window.__dtxNav(url)};m.supports=function(){return false};m.useCustomClose=function(){};var g=function(){try{return window.$sf&&window.$sf.ext&&window.$sf.ext.geom()}catch(e){return null}};m.getVersion=function(){return '3.0'};m.getPlacementType=function(){return 'inline'};m.getScreenSize=function(){var o=g();return o?{width:o.win.w,height:o.win.h}:{width:window.innerWidth,height:window.innerHeight}};m.getMaxSize=m.getScreenSize;m.getCurrentPosition=function(){var o=g();return o?{x:o.self.l,y:o.self.t,width:o.self.w,height:o.self.h}:{x:0,y:0,width:window.innerWidth,height:window.innerHeight}};m.getDefaultPosition=m.getCurrentPosition;m.getExpandProperties=function(){var z=m.getMaxSize();return {width:z.width,height:z.height,useCustomClose:false,isModal:true}};m.setExpandProperties=function(){};var ready=function(){s='default';f('stateChange',s);f('ready')};document.readyState==='complete'||document.readyState==='interactive'?ready():document.addEventListener('DOMContentLoaded',ready);})();<\/script>`,
      o = `<script>(function(){${a}
var ct=${JSON.stringify(e)},ctAt=0;
var ael=EventTarget.prototype.addEventListener;
var hasTouch=false,hasMouse=false;
try{
var patched=function(t){if(t==='touchstart'||t==='touchend'||t==='touchmove'){hasTouch=true}else if(t==='click'||t==='mousedown'||t==='mouseup'||t==='pointerdown'){hasMouse=true}return ael.apply(this,arguments)};
try{Object.defineProperty(patched,'name',{value:'addEventListener',configurable:true})}catch(e){}
try{Object.defineProperty(patched,'length',{value:ael.length,configurable:true})}catch(e){}
try{Object.defineProperty(patched,'toString',{value:function(){return ael.toString()},writable:true,configurable:true})}catch(e){}
Object.defineProperty(EventTarget.prototype,'addEventListener',{value:patched,writable:true,configurable:true,enumerable:false});
}catch(e){}
function anchorOf(n){while(n&&n.tagName!=='A'){n=n.parentElement}return n}
function synthTouch(e){
if(typeof Touch!=='function'||typeof TouchEvent!=='function'){if(DBG)console.log('[DTX touch bridge] TouchEvent unsupported here');return}
try{
var t=new Touch({identifier:1,target:e.target,clientX:e.clientX,clientY:e.clientY,pageX:e.pageX,pageY:e.pageY,screenX:e.screenX,screenY:e.screenY,radiusX:1,radiusY:1,force:1});
e.target.dispatchEvent(new TouchEvent('touchstart',{bubbles:true,cancelable:true,composed:true,touches:[t],targetTouches:[t],changedTouches:[t]}));
e.target.dispatchEvent(new TouchEvent('touchend',{bubbles:true,cancelable:true,composed:true,touches:[],targetTouches:[],changedTouches:[t]}));
if(DBG)console.log('[DTX touch bridge] synthesized touchstart/touchend for touch-only creative');
}catch(err){if(DBG)console.log('[DTX touch bridge] failed',err&&err.message)}}
function fireCt(){if(Date.now()-ctAt<1000)return;ctAt=Date.now();ct.forEach(function(u){new Image().src=u})}
function onClick(e){
var a=anchorOf(e.target);
if(a&&a.href&&!e.defaultPrevented){e.preventDefault();fireCt();window.__dtxNav(a.href);return}
if(hasTouch&&!hasMouse&&!e.defaultPrevented&&!document.querySelector('[onclick]')){synthTouch(e)}}
function onTouch(e){
var a=anchorOf(e.target);
if(a&&a.href&&!e.defaultPrevented){fireCt();window.__dtxNav(a.href)}}
ael.call(document,'click',onClick,false);
ael.call(document,'touchstart',onTouch,{capture:false,passive:true});
})();<\/script>`,
      c =
        '<meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests">' +
        s +
        d +
        o;
    return r.toLowerCase().indexOf('<html') < 0
      ? `<!DOCTYPE html><html><head><style>html,body{margin:0;padding:0;overflow:hidden;touch-action:manipulation;}</style>${c}</head><body>${r}</body></html>`
      : /<head[ >]/i.test(r)
        ? r.replace(/<head[^>]*>/i, (m) => `${m}${c}`)
        : /<body[ >]/i.test(r)
          ? r.replace(/<body[^>]*>/i, (m) => `${m}${c}`)
          : c + r;
  }
  const se =
      (typeof {
        url:
          typeof document > 'u' && typeof location > 'u'
            ? require('url').pathToFileURL(__filename).href
            : typeof document > 'u'
              ? location.href
              : (C && C.tagName.toUpperCase() === 'SCRIPT' && C.src) ||
                new URL('dtx-web-sdk.umd.cjs', document.baseURI).href,
      } < 'u' &&
        'v0.1.22') ||
      '1.0.0',
    oe = 'https://wv.inner-active.mobi/simpleM2M/contentMedia',
    de = new _({
      attempts: 5,
      maxDuration: 3e4,
      initialDelay: 250,
      httpTimeout: 3e3,
    }).getAdClient();
  function ce(i, e) {
    const t = i.params,
      r = i.mediaTypes?.banner,
      n = r?.sizes || i.sizes || [],
      a = t.placementId ?? t.placement_id ?? i.adUnitCode,
      d = { gpid: i.ortb2Imp?.ext?.gpid ?? a };
    i.ortb2Imp?.ext?.tid && (d.tid = i.ortb2Imp.ext.tid),
      (t.placementId ?? t.placement_id) &&
        (d.placementId = t.placementId ?? t.placement_id);
    const o = {
      id: i.bidId,
      tagid: a,
      secure: (e.refererInfo?.page ?? '').startsWith('https') ? 1 : 0,
      displaymanager: 'DigitalTurbine',
      instl: 0,
      rwdd: 0,
      ext: d,
    };
    r &&
      (o.banner = {
        w: n[0]?.[0] ?? 0,
        h: n[0]?.[1] ?? 0,
        format: n.map(([k, S]) => ({ w: k, h: S })),
        pos: 1,
        mimes: [
          'text/html',
          'text/javascript',
          'image/png',
          'image/jpeg',
          'image/gif',
        ],
      });
    const u = navigator.userAgent,
      c = F(u),
      h = e.ortb2?.device ?? {},
      m = l.getInstance()._getConfig(),
      T = m?.hostingAppDetails,
      w = {},
      g = {
        ua: u,
        language: (navigator.language ?? 'en').split('-')[0],
        devicetype: B(),
        dnt: navigator.doNotTrack === '1' ? 1 : 0,
        lmt: 0,
        ...c,
      };
    if (m?.advertiserId)
      (g.ifa = m.advertiserId),
        (w.ifa_type = m.advertiserIdType === 'ios' ? 'idfa' : 'aaid');
    else if (h.ifa)
      (g.ifa = h.ifa),
        (w.ifa_type = h.ifa_type ?? (c.os === 'android' ? 'aaid' : 'idfa'));
    else
      try {
        const S = new URL(e.refererInfo?.page ?? '').searchParams.get('aaid');
        S && ((g.ifa = S), (w.ifa_type = 'aaid'));
      } catch {}
    Object.keys(w).length > 0 && (g.ext = w),
      h.w && (g.w = h.w),
      h.h && (g.h = h.h),
      h.sua && (g.sua = h.sua);
    const M = N(se) ?? { major: 1, minor: 0, micro: 0 },
      y = e.ortb2?.site ?? {},
      v = e.ortb2?.app ?? {},
      { site: f, app: I } = H({
        siteId: t.appId ?? t.siteId,
        publisherId: t.appId ?? t.publisherId ?? t.siteId,
        domain: e.refererInfo?.domain ?? '',
        page: e.refererInfo?.page ?? '',
        sdkVersion: M,
        appBundle: T?.packageName ?? v.bundle,
        appName: T?.appName ?? v.name,
        appVer: T?.appVersion ?? v.ver,
      });
    f &&
      (y.name && (f.name = y.name),
      y.cat && (f.cat = y.cat),
      y.keywords && (f.keywords = y.keywords));
    const D = { gdpr: 0, us_privacy: e.uspConsent ?? '1---' };
    e.gdprConsent?.gdprApplies &&
      ((D.gdpr = 1), (D.consent = e.gdprConsent.consentString));
    const A = {
      id: e.auctionId,
      imp: [o],
      ...(I ? { app: I } : { site: f }),
      device: g,
      tmax: t.tmax ?? 5e3,
      cur: ['USD'],
      regs: { ext: D },
    };
    i.schain && (A.source = { ext: { schain: i.schain } }),
      t.testData && (A.ext = t.testData);
    const L = m?.userId ?? i.userId?.pubcid ?? i.userId?.id5id?.uid,
      P = i.userIdAsEids ?? [];
    if (L || P.length > 0) {
      const k = {};
      L && (k.id = L), P.length > 0 && (k.ext = { eids: P }), (A.user = k);
    }
    return {
      method: 'POST',
      url: oe,
      data: JSON.stringify(A),
      bidId: i.bidId,
      requestedWidth: n[0]?.[0],
      requestedHeight: n[0]?.[1],
      options: { contentType: 'application/json', withCredentials: !1 },
    };
  }
  const j = {
    code: 'dtx',
    gvlid: 0,
    supportedMediaTypes: ['banner', 'video', 'native'],
    isBidRequestValid(i) {
      return !!i.params?.appId;
    },
    buildRequests(i, e) {
      return i.map((t) => ce(t, e));
    },
    interpretResponse(i, e) {
      if (!i?.body?.seatbid) return [];
      const t = [];
      return (
        i.body.seatbid.forEach((r) => {
          (r.bid ?? []).forEach((n) => {
            const a = n.ext?.imptrackers ?? [],
              s = n.ext?.clicktrackers ?? [],
              d = {
                requestId: n.impid ?? e?.bidId ?? n.id ?? '',
                cpm: n.price,
                currency: i.body?.cur ?? 'USD',
                width: n.w || e?.requestedWidth,
                height: n.h || e?.requestedHeight,
                creativeId: n.crid ?? n.id,
                campaignId: n.cid,
                netRevenue: !0,
                ttl: 300,
                meta: { advertiserDomains: n.adomain ?? [] },
                impressionTrackers: a,
              };
            n.vastxml
              ? (d.vastXml = n.vastxml)
              : n.vasturl
                ? (d.vastUrl = n.vasturl)
                : n.adm && (d.ad = ae(n.adm, s)),
              t.push(d);
          });
        }),
        t
      );
    },
    getUserSyncs() {
      return [];
    },
    onBidWon(i) {
      (i.impressionTrackers ?? []).forEach((e) => {
        de.fireAndForget(e).catch(() => {});
      });
    },
  };
  (window.DTXWeb = l),
    (window.DTXWebPrebidSpec = j),
    (b.DTXWeb = l),
    (b.dtxPrebidSpec = j),
    Object.defineProperty(b, Symbol.toStringTag, { value: 'Module' });
});
